import { Component, OnInit, Inject } from '@angular/core';
import { DialogService } from '../../../shared/services/dialog.service';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { BaseService } from '../../../shared/services/base.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { Page } from '../../../models/list/page.model';

import { BookingDetailFluVaccineService } from './booking-detail-fluvaccine.service';
import { BookingDetailsFluVaccineModel } from '../../../models/booking/booking-details.model';


@Component({
    selector: 'app-booking-details',
    templateUrl: 'booking-detail-fluvaccine.component.html',
    providers: [BookingDetailFluVaccineService]
})
export class BookingDetailsFluVaccinePopupComponent implements OnInit  {
    public page = new Page();
    public dataMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total
    };
    public appConstants = AppConstants;
    public bookingForm: FormGroup;
    public dataDetails = new BookingDetailsFluVaccineModel();
    public dataRow = [];
    public success = false;
    public dataStaffRemove = [];
    public customClasses = AppConstants.table.footerClasses;
    constructor(
        public dialogService: DialogService,
        private formBuilder: FormBuilder,
        @Inject(MD_DIALOG_DATA) public data: any,
        public dialogRef: MdDialogRef<BookingDetailsFluVaccinePopupComponent>,
        public bookingDetailFluVaccineService: BookingDetailFluVaccineService
    ) {
        this.createForm();
    }
    ngOnInit()  {
        this.page.size = 5;
        this.page.totalElements = 5;
        this.page.totalPages = 1;
        this.page.pageNumber = 0;
        this.setPage({ offset: 0 });
        //this.initData();
    }

    onCloseDialog(success = false) {
        this.dialogRef.close(success);
    }

    createForm() {
        this.bookingForm = this.formBuilder.group({
            id: '',
            bookingREF: '',
            date: '',
            fromTime: '',
            toTime: '',
            groupName: '',
        });
    }

    setPage(pageInfo) {
        let param ={
            StartTime: this.data.startTime,
            EndTime: this.data.endTime
        };
        this.bookingDetailFluVaccineService.getFluVaccineBookingDetail(this.data.id, param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataDetails = data;
                    this.dataRow = data['members'];
                    //this.initData();
                }
            }
        );
    }

    // initData() {
    //     this.dataDetails = this.bookingDetailFluVaccineService.getDataDetailsFluVaccine();
    //     this.dataRow = JSON.parse(JSON.stringify(this.bookingDetailFluVaccineService.getDataRowListStaff()));
    // }

    onRemoveItem(row) {
        // remove row patient
        const index = this.dataRow.indexOf(row);
        this.dataStaffRemove.push(row.id);
        this.dataRow.splice(index, 1);
        // if remove success reset page
        //this.setPage({ offset: 0 });
    }

    onSubmit() {
        // if save call api  and save data table
        this.dataDetails.members = this.dataStaffRemove;
        this.bookingDetailFluVaccineService.updateFluVaccineBookingDetail(this.dataDetails.members).subscribe(
            (result) => {
                if (result){
                    this.success = true;
                    this.onCloseDialog(this.success);
                }
            }
        )
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/booking-detail/booking-detail-fluvaccine.component.ts